module.exports = __webpack_public_path__ + "img/우리카드.f12a04fd.png";